/* eslint-disable */
export default {
  cancel: 'Cancelar',
  reply: 'Responder',
  onMyWay: 'Estou a caminho',
  customMessage: 'Mensagem personalizada',
  callMeBackIn: 'Ligue de novo em',
  willCallYouBackIn: 'Retornarei a chamada em',
  min: 'min',
  hours: 'horas',
  days: 'dias',
} as const;

// @key: @#@"cancel"@#@ @source: @#@"Cancel"@#@
// @key: @#@"reply"@#@ @source: @#@"Reply"@#@
// @key: @#@"onMyWay"@#@ @source: @#@"On my way"@#@
// @key: @#@"customMessage"@#@ @source: @#@"Custom Message"@#@
// @key: @#@"callMeBackIn"@#@ @source: @#@"Call me back in"@#@
// @key: @#@"willCallYouBackIn"@#@ @source: @#@"Will call you back in"@#@
// @key: @#@"min"@#@ @source: @#@"min"@#@
// @key: @#@"hours"@#@ @source: @#@"hours"@#@
// @key: @#@"days"@#@ @source: @#@"days"@#@
